import { FC, memo } from 'react';
import { appsflyerBannerScript } from 'packages/appsflyer-plugin/api';
import { isCordova } from 'packages/platform-detector';
import { useAcpSessionStorage } from 'apps/acp/packages/use-acp-storage';
import { getUrlSearchParams } from 'packages/url-parser';

declare global {
  interface Window {
    AF: any;
  }
}

const useAppsflyerBanner = (key: string) => {
  const [redirectParam, , removeRedirectParam] = useAcpSessionStorage(
    'post_login_redirect_parameters',
    '{}'
  );
  const [redirectUrl, setRedirectUrl] = useAcpSessionStorage(
    'post_login_redirect_url',
    ''
  );

  try {
    let hasAfParam = redirectParam?.af;

    /**
     * if user is coming from react route, query param appended
     * to 'acp_post_login_redirect_url' session key.
     * so verifying if redirect_url has the required param.
     */

    const [path, queryParam] = redirectUrl?.split('?');
    const afParamValue = getUrlSearchParams<string>('af', queryParam);
    if (!hasAfParam && afParamValue) {
      hasAfParam = afParamValue;
      // update the redirect URL in session so that it wouldn't run on refresh/reload
      setRedirectUrl(path);
    }

    // trigger banner script to load in browser
    if (!isCordova() && hasAfParam) {
      appsflyerBannerScript(key);
      window.AF('banners', 'showBanner', {
        additionalParams: { deep_link_value: redirectUrl }
      });
      removeRedirectParam();
    }
  } catch (error) {
    window.console.log('[Appsflyer Banner]', error);
  }
};

export const ShowAppsflyerBanner: FC<{ bannerId: string }> = memo(
  ({ bannerId = '' }) => {
    useAppsflyerBanner(bannerId);
    return null;
  }
);

export const HideAppsflyerBanner = () => {
  if (!isCordova() && window.AF) {
    window.AF('banners', 'hideBanner');
  }
  return null;
};
